export default "__VITE_ASSET__B9Gc_mhq__"